<app-headerthree></app-headerthree>
<app-content></app-content>
<app-footer [layout]="classname" [logo]="ftlogo"></app-footer>